var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useSession } from '@/contexts/LitSessionProvider';
import { useUserCloudQuery } from '@/hooks/onboarding/useReferralQuery';
import { useEffect } from 'react';
export default function useGetUserProfileInfo() {
    var _a, _b, _c, _d, _e;
    var _f = useSession(), clearLitSession = _f.clearLitSession, PKP = _f.PKP, setPKP = _f.setPKP;
    var _g = useUserCloudQuery(PKP), userCloudData = _g.data, isLoading = _g.isLoading;
    var PFP = "static/genie/".concat((_a = userCloudData === null || userCloudData === void 0 ? void 0 : userCloudData.data) === null || _a === void 0 ? void 0 : _a.pfp);
    var firstName = (_b = userCloudData === null || userCloudData === void 0 ? void 0 : userCloudData.data) === null || _b === void 0 ? void 0 : _b.first_name;
    var lastName = (_c = userCloudData === null || userCloudData === void 0 ? void 0 : userCloudData.data) === null || _c === void 0 ? void 0 : _c.last_name;
    var userName = (_d = userCloudData === null || userCloudData === void 0 ? void 0 : userCloudData.data) === null || _d === void 0 ? void 0 : _d.username;
    var userId = (_e = userCloudData === null || userCloudData === void 0 ? void 0 : userCloudData.data) === null || _e === void 0 ? void 0 : _e.user_id;
    useEffect(function () {
        if ((firstName, lastName, userName)) {
            setPKP(__assign(__assign({}, PKP), { firstName: firstName, lastName: lastName, username: userName }));
        }
    }, [useGetUserProfileInfo]);
    return { PFP: PFP, firstName: firstName, lastName: lastName, userName: userName, userId: userId };
}
